import { render, staticRenderFns } from "./WorkSpaceGroup.vue?vue&type=template&id=3aeb79d8&scoped=true&"
import script from "./WorkSpaceGroup.vue?vue&type=script&lang=js&"
export * from "./WorkSpaceGroup.vue?vue&type=script&lang=js&"
import style0 from "./WorkSpaceGroup.vue?vue&type=style&index=0&id=3aeb79d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb79d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
